import React, { Fragment } from "react";
import { FlexBox } from "~/components/.base/containers";
import { Subheading, BodyTextAlt } from "~/components/.base/headings";
import ClockIcon from "~/images/icons/location_clock.svg";

const RestaurantScheduleMobile = ({
	restaurantSchedule,
	formatDate,
	weekDates,
}) => {
	console.log("WDS: ", weekDates);
	return (
		<div className="mobile-schedule">
			{restaurantSchedule && weekDates && weekDates.length ? (
				<Fragment>
					<FlexBox justify="space-between">
						<Subheading>{formatDate(weekDates[0])}</Subheading>
						<FlexBox align="center">
							<ClockIcon />
							<BodyTextAlt md="0 0 0 .5rem">
								{restaurantSchedule.sundayHours}
							</BodyTextAlt>
						</FlexBox>
					</FlexBox>
					<FlexBox justify="space-between">
						<Subheading>{formatDate(weekDates[1])}</Subheading>
						<FlexBox align="center">
							<ClockIcon />
							<BodyTextAlt md="0 0 0 .5rem">
								{restaurantSchedule.mondayHours}
							</BodyTextAlt>
						</FlexBox>
					</FlexBox>
					<FlexBox justify="space-between">
						<Subheading>{formatDate(weekDates[2])}</Subheading>
						<FlexBox align="center">
							<ClockIcon />
							<BodyTextAlt md="0 0 0 .5rem">
								{restaurantSchedule.tuesdayHours}
							</BodyTextAlt>
						</FlexBox>
					</FlexBox>
					<FlexBox justify="space-between">
						<Subheading>{formatDate(weekDates[3])}</Subheading>
						<FlexBox align="center">
							<ClockIcon />
							<BodyTextAlt md="0 0 0 .5rem">
								{restaurantSchedule.wednesdayHours}
							</BodyTextAlt>
						</FlexBox>
					</FlexBox>
					<FlexBox justify="space-between">
						<Subheading>{formatDate(weekDates[4])}</Subheading>
						<FlexBox align="center">
							<ClockIcon />
							<BodyTextAlt md="0 0 0 .5rem">
								{restaurantSchedule.thursdayHours}
							</BodyTextAlt>
						</FlexBox>
					</FlexBox>
					<FlexBox justify="space-between">
						<Subheading>{formatDate(weekDates[5])}</Subheading>
						<FlexBox align="center">
							<ClockIcon />
							<BodyTextAlt md="0 0 0 .5rem">
								{restaurantSchedule.fridayHours}
							</BodyTextAlt>
						</FlexBox>
					</FlexBox>
					<FlexBox justify="space-between">
						<Subheading>{formatDate(weekDates[6])}</Subheading>
						<FlexBox align="center">
							<ClockIcon />
							<BodyTextAlt md="0 0 0 .5rem">
								{restaurantSchedule.saturdayHours}
							</BodyTextAlt>
						</FlexBox>
					</FlexBox>
				</Fragment>
			) : null}
		</div>
	);
};

export default RestaurantScheduleMobile;
